import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages(
    'pages.RequestFormPage.XeroAirwallexBatchPaymentForm.BillsInformation.AddBeneficiaryPopupContent',
    {
        popupTitle: 'Create beneficiary',
        nextStepButtonText: 'NEXT',
        prevStepButtonText: 'BACK',
        createButtonText: 'CREATE',
        unknownError: 'Unknown error',
        notSupported: 'Not supported. Please try a different combination.',
        notSupportedCurrency: 'Airwallex does not support the currency of the bill ({currency}).',
        twoFaPopupTitle: 'Complete beneficiary creation via the Authenticator app',
        localClearingSystem: 'Local clearing system',
        customerReferenceNumber: 'Customer reference number (CRN)',
    }
);
